// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1evgt","buttons":"RemoveExpirationActionButtons_buttons__185Uv"};